import React from "react"
import { styled } from "@mui/material/styles"
import Typography from "@mui/material/Typography"
import { OPEN_SEND_OTP_BOTTOM_SHEET, SHOW_NO_EMAIL_FOUND_MODAL } from "constants/events"
import { useTranslation } from "react-i18next"
import { useAuth } from "context/AuthContext"

export default function ForgetPasswordQuestion() {
  const { t } = useTranslation()

  const { isAuthenticated, user } = useAuth()

  function openSendOTPBottomSheet() {
    if (isAuthenticated && !!user && !user?.email) {
      document.dispatchEvent(new CustomEvent(SHOW_NO_EMAIL_FOUND_MODAL))
      return
    }
    document.dispatchEvent(new CustomEvent(OPEN_SEND_OTP_BOTTOM_SHEET))
  }

  return (
    <ForgotPassword onClick={openSendOTPBottomSheet}>
      {t("auth.forgotPasswordQuestion")}
    </ForgotPassword>
  )
}

const ForgotPassword = styled(Typography)(({ theme }) => ({
  fontSize: "1.2rem",
  color: theme.palette.primary["6"],
  fontWeight: 500,
  textDecoration: "none",
  marginTop: "-2.8rem",
  marginBottom: "5rem"
}))
